"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VendorTimescaleIcon = exports.VendorRedisIcon = exports.VendorPostgresqlIcon = exports.VendorPerconaIcon = exports.VendorOracleIcon = exports.VendorMysqlIcon = exports.VendorMongodbIcon = exports.VendorMariadbIcon = exports.VendorCodershipIcon = exports.VendorAwsRdsIcon = exports.TreeIcon = exports.SupportIcon = exports.SuccessIcon = exports.ServersIcon = exports.ServerIcon = exports.SchedulesIcon = exports.RemoteConnectionIcon = exports.PlayIcon = exports.PauseIcon = exports.PartialBackupIcon = exports.OsWindowsIcon = exports.OsUbuntuIcon = exports.OsRedhatIcon = exports.OsMintIcon = exports.OsMacosIcon = exports.OsLinuxIcon = exports.OsDebianIcon = exports.OsCentosIcon = exports.LockIcon = exports.LocalStorageIcon = exports.LocalConnectionIcon = exports.IncrementalBackupIcon = exports.FolderIcon = exports.FileIcon = exports.FeedbackIcon = exports.FailIcon = exports.EncryptionIcon = exports.DownloadIcon = exports.DoubleUpIcon = exports.DoubleDownIcon = exports.DotIcon = exports.DocumentationIcon = exports.DatabaseIcon = exports.DashboardIcon = exports.CompressionIcon = exports.CloudStorageIcon = exports.BinaryWalFileIcon = exports.BinaryLogFileIcon = exports.BinaryFileIcon = exports.BellIcon = exports.BackupsIcon = exports.BackupRestoreIcon = exports.BackupDecryptIcon = exports.AccountIcon = void 0;

require("core-js/modules/es.object.assign");

require("./icons.less");

var _react = _interopRequireDefault(require("react"));

var _AppIcon = _interopRequireDefault(require("./AppIcon"));

var _svgSources = require("./svgSources");

var LocalStorageIcon = function LocalStorageIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgLocalStorage
  }, props));
};

exports.LocalStorageIcon = LocalStorageIcon;

var CloudStorageIcon = function CloudStorageIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgCloudStorage
  }, props));
};

exports.CloudStorageIcon = CloudStorageIcon;

var EncryptionIcon = function EncryptionIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgEncryption
  }, props));
};

exports.EncryptionIcon = EncryptionIcon;

var CompressionIcon = function CompressionIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgCompression
  }, props));
};

exports.CompressionIcon = CompressionIcon;

var DotIcon = function DotIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDot
  }, props));
};

exports.DotIcon = DotIcon;

var PlayIcon = function PlayIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgPlay
  }, props));
};

exports.PlayIcon = PlayIcon;

var PauseIcon = function PauseIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgPause
  }, props));
}; //vendors


exports.PauseIcon = PauseIcon;

var VendorAwsRdsIcon = function VendorAwsRdsIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/awsrds'
  }, props));
};

exports.VendorAwsRdsIcon = VendorAwsRdsIcon;

var VendorMysqlIcon = function VendorMysqlIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/mysql'
  }, props));
};

exports.VendorMysqlIcon = VendorMysqlIcon;

var VendorMariadbIcon = function VendorMariadbIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/mariadb'
  }, props));
};

exports.VendorMariadbIcon = VendorMariadbIcon;

var VendorMongodbIcon = function VendorMongodbIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/mongodb'
  }, props));
};

exports.VendorMongodbIcon = VendorMongodbIcon;

var VendorTimescaleIcon = function VendorTimescaleIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/timescaledb'
  }, props));
};

exports.VendorTimescaleIcon = VendorTimescaleIcon;

var VendorOracleIcon = function VendorOracleIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/oracle'
  }, props));
};

exports.VendorOracleIcon = VendorOracleIcon;

var VendorCodershipIcon = function VendorCodershipIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/codership'
  }, props));
};

exports.VendorCodershipIcon = VendorCodershipIcon;

var VendorPerconaIcon = function VendorPerconaIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/percona'
  }, props));
};

exports.VendorPerconaIcon = VendorPerconaIcon;

var VendorPostgresqlIcon = function VendorPostgresqlIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/postgresql'
  }, props));
};

exports.VendorPostgresqlIcon = VendorPostgresqlIcon;

var VendorRedisIcon = function VendorRedisIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'vendor/redis'
  }, props));
}; // os


exports.VendorRedisIcon = VendorRedisIcon;

var OsCentosIcon = function OsCentosIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/centos'
  }, props));
};

exports.OsCentosIcon = OsCentosIcon;

var OsDebianIcon = function OsDebianIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/debian'
  }, props));
};

exports.OsDebianIcon = OsDebianIcon;

var OsLinuxIcon = function OsLinuxIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/linux'
  }, props));
};

exports.OsLinuxIcon = OsLinuxIcon;

var OsMacosIcon = function OsMacosIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/macos'
  }, props));
};

exports.OsMacosIcon = OsMacosIcon;

var OsMintIcon = function OsMintIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/mint'
  }, props));
};

exports.OsMintIcon = OsMintIcon;

var OsRedhatIcon = function OsRedhatIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/redhat'
  }, props));
};

exports.OsRedhatIcon = OsRedhatIcon;

var OsUbuntuIcon = function OsUbuntuIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/ubuntu'
  }, props));
};

exports.OsUbuntuIcon = OsUbuntuIcon;

var OsWindowsIcon = function OsWindowsIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: 'os/windows'
  }, props));
}; // items


exports.OsWindowsIcon = OsWindowsIcon;

var ServerIcon = function ServerIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgServer
  }, props));
};

exports.ServerIcon = ServerIcon;

var DashboardIcon = function DashboardIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDashboard
  }, props));
};

exports.DashboardIcon = DashboardIcon;

var BackupsIcon = function BackupsIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBackups
  }, props));
};

exports.BackupsIcon = BackupsIcon;

var SchedulesIcon = function SchedulesIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgSchedules
  }, props));
};

exports.SchedulesIcon = SchedulesIcon;

var ServersIcon = function ServersIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgServers
  }, props));
};

exports.ServersIcon = ServersIcon;

var AccountIcon = function AccountIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgAccount
  }, props));
};

exports.AccountIcon = AccountIcon;

var SupportIcon = function SupportIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgSupport
  }, props));
};

exports.SupportIcon = SupportIcon;

var DocumentationIcon = function DocumentationIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDocumentation
  }, props));
};

exports.DocumentationIcon = DocumentationIcon;

var FeedbackIcon = function FeedbackIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgFeedback
  }, props));
};

exports.FeedbackIcon = FeedbackIcon;

var BackupRestoreIcon = function BackupRestoreIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBackupRestore
  }, props));
};

exports.BackupRestoreIcon = BackupRestoreIcon;

var BackupDecryptIcon = function BackupDecryptIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBackupDecrypt
  }, props));
};

exports.BackupDecryptIcon = BackupDecryptIcon;

var DownloadIcon = function DownloadIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDownload
  }, props));
};

exports.DownloadIcon = DownloadIcon;

var SuccessIcon = function SuccessIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgCheck
  }, props));
};

exports.SuccessIcon = SuccessIcon;

var FailIcon = function FailIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgCross
  }, props));
};

exports.FailIcon = FailIcon;

var FileIcon = function FileIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgFile
  }, props));
};

exports.FileIcon = FileIcon;

var DoubleDownIcon = function DoubleDownIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDoubleDown
  }, props));
};

exports.DoubleDownIcon = DoubleDownIcon;

var DoubleUpIcon = function DoubleUpIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDoubleUp
  }, props));
};

exports.DoubleUpIcon = DoubleUpIcon;

var DatabaseIcon = function DatabaseIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgDatabase
  }, props));
};

exports.DatabaseIcon = DatabaseIcon;

var LockIcon = function LockIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgLock
  }, props));
};

exports.LockIcon = LockIcon;

var FolderIcon = function FolderIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgFolder
  }, props));
};

exports.FolderIcon = FolderIcon;

var TreeIcon = function TreeIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgTree
  }, props));
};

exports.TreeIcon = TreeIcon;

var BellIcon = function BellIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBell
  }, props));
};

exports.BellIcon = BellIcon;

var PartialBackupIcon = function PartialBackupIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgPartialBackup
  }, props));
};

exports.PartialBackupIcon = PartialBackupIcon;

var RemoteConnectionIcon = function RemoteConnectionIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgRemoteConnection
  }, props));
};

exports.RemoteConnectionIcon = RemoteConnectionIcon;

var LocalConnectionIcon = function LocalConnectionIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgLocalConnection
  }, props));
};

exports.LocalConnectionIcon = LocalConnectionIcon;

var IncrementalBackupIcon = function IncrementalBackupIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgIncrementalBackup
  }, props));
};

exports.IncrementalBackupIcon = IncrementalBackupIcon;

var BinaryFileIcon = function BinaryFileIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBinaryFile
  }, props));
};

exports.BinaryFileIcon = BinaryFileIcon;

var BinaryLogFileIcon = function BinaryLogFileIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBinaryLogFile
  }, props));
};

exports.BinaryLogFileIcon = BinaryLogFileIcon;

var BinaryWalFileIcon = function BinaryWalFileIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_AppIcon.default, Object.assign({
    icon: _svgSources.svgBinaryWalFile
  }, props));
};

exports.BinaryWalFileIcon = BinaryWalFileIcon;